import React, { useEffect, useState, lazy } from 'react';
export const SpecialOffer = () => {
  const [copiesLeft, setCopiesLeft] = useState(374);
  useEffect(() => {
    // Get stored value from localStorage or use default
    const storedCopies = localStorage.getItem('copiesLeft');
    const initialCopies = storedCopies ? parseInt(storedCopies) : 374;
    setCopiesLeft(initialCopies);
    // Decrease count randomly every 3 seconds
    const interval = setInterval(() => {
      setCopiesLeft(prevCount => {
        // Random decrease between 1-3
        const decrease = Math.floor(Math.random() * 3) + 1;
        const newCount = Math.max(prevCount - decrease, 5); // Don't go below 5
        // Store in localStorage
        localStorage.setItem('copiesLeft', newCount.toString());
        return newCount;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div id="offer" className="py-20 bg-gradient-to-br from-blue-100 via-white to-red-100 relative" data-id="element-152">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-153">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-154"></div>
      </div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <h2 className="inline-block text-3xl md:text-4xl font-bold text-gray-900 mb-4 px-8 py-2 border-b-4 border-red-700 relative" data-id="element-157">
            <span className="text-blue-700 mr-3" data-id="element-158">★</span>
            Special American Values Offer
            <span className="text-red-700 ml-3" data-id="element-159">★</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-160">
            Get immediate access to Charlie Kirk's life story, philosophy, and
            legacy
          </p>
        </div>
        {/* Mobile Book Previews Section - Only visible on mobile */}
        <div className="md:hidden space-y-4 mb-6" data-id="element-161">
          {/* First Book Preview - Remembering Charlie Kirk */}
          <div className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm relative" data-id="element-162">
            {/* Free Bonus Badge */}
            <div className="absolute -top-2 -left-2 bg-red-600 text-white text-xs font-bold py-1 px-2 rounded-full shadow-md" data-id="element-163">
              FREE BONUS
            </div>
            <div className="w-1/3 flex-shrink-0 relative" data-id="element-164">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/baeA1GkLNLNH7mDtU8UUPC/Generated_Image_September_18%2C_2025_-_10_53AM.png" alt="Remembering Charlie Kirk Book Cover" className="w-full rounded-md shadow-sm" loading="lazy" width="120" height="180" decoding="async" data-id="element-165" />
              {/* Pricing information under image */}
              <div className="mt-2 text-center" data-id="element-166">
                <p className="text-xs" data-id="element-167">
                  <span className="line-through text-gray-500" data-id="element-168">$47.97</span>{' '}
                  <span className="font-bold text-green-700" data-id="element-169">Today: $0.00</span>
                </p>
              </div>
            </div>
            <div className="w-2/3" data-id="element-170">
              <h3 className="text-sm font-bold text-blue-800 mb-1" data-id="element-171">
                Remembering Charlie Kirk
              </h3>
              <p className="text-xs text-gray-700 mb-2" data-id="element-172">
                A heartfelt tribute to a man whose voice and vision shaped a
                generation. Through powerful stories and reflections, this book
                preserves both his public influence and private humanity.
              </p>
              <div className="flex items-center justify-between" data-id="element-173">
                <div className="flex items-center" data-id="element-174">
                  <div className="text-yellow-500 flex mr-2" data-id="element-175">
                    {[...Array(5)].map((_, i) => <svg key={i} className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24" data-id="element-176">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-177" />
                      </svg>)}
                  </div>
                  <span className="text-xs text-gray-600" data-id="element-178">850+ readers</span>
                </div>
                <span className="text-xs font-bold text-green-700" data-id="element-179">
                  TODAY: FREE
                </span>
              </div>
            </div>
          </div>
          {/* Second Book Preview - The Last Patriot */}
          <div className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm relative" data-id="element-180">
            {/* Free Bonus Badge */}
            <div className="absolute -top-2 -left-2 bg-red-600 text-white text-xs font-bold py-1 px-2 rounded-full shadow-md" data-id="element-181">
              FREE BONUS
            </div>
            <div className="w-1/3 flex-shrink-0 relative" data-id="element-182">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1TCPbq6QpWBgTxiHkTQA8Q/Generated_Image_September_18%2C_2025_-_10_53AM.png" alt="The Last Patriot Book Cover" className="w-full rounded-md shadow-sm" loading="lazy" width="120" height="180" decoding="async" data-id="element-183" />
              {/* Pricing information under image */}
              <div className="mt-2 text-center" data-id="element-184">
                <p className="text-xs" data-id="element-185">
                  <span className="line-through text-gray-500" data-id="element-186">$47.97</span>{' '}
                  <span className="font-bold text-green-700" data-id="element-187">Today: $0.00</span>
                </p>
              </div>
            </div>
            <div className="w-2/3" data-id="element-188">
              <h3 className="text-sm font-bold text-blue-800 mb-1" data-id="element-189">
                The Last Patriot™
              </h3>
              <p className="text-xs text-gray-700 mb-2" data-id="element-190">
                An explosive inside look at the movement reshaping America. From
                the alliance between Trump and Kirk to the rise of Turning Point
                USA, this book uncovers the strategies that ignited a new wave
                of patriotism.
              </p>
              <div className="flex items-center justify-between" data-id="element-191">
                <div className="flex items-center" data-id="element-192">
                  <div className="text-yellow-500 flex mr-2" data-id="element-193">
                    {[...Array(5)].map((_, i) => <svg key={i} className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24" data-id="element-194">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-195" />
                      </svg>)}
                  </div>
                  <span className="text-xs text-gray-600" data-id="element-196">1,100+ readers</span>
                </div>
                <span className="text-xs font-bold text-green-700" data-id="element-197">
                  TODAY: FREE
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Main offer card */}
        <div className="bg-white rounded-xl shadow-2xl border border-gray-200 mb-12 overflow-hidden" data-id="element-198">
          {/* Countdown banner */}
          <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white text-center py-3 sm:py-4 px-2 sm:px-4" data-id="element-199">
            <p className="font-bold text-sm sm:text-lg md:text-xl flex flex-wrap items-center justify-center" data-id="element-200">
              <span className="animate-pulse mr-1 sm:mr-2" data-id="element-201">⚠️</span>
              URGENT: Only{' '}
              <span className="text-yellow-300 text-base sm:text-xl md:text-2xl mx-1 sm:mx-2 font-black" data-id="element-202">
                {copiesLeft}
              </span>{' '}
              copies left at this price!
              <span className="animate-pulse ml-1 sm:ml-2" data-id="element-203">⚠️</span>
            </p>
          </div>
          {/* Modified layout to be consistent across all screen sizes */}
          <div className="p-8" data-id="element-204">
            <div className="flex flex-col items-center mb-8" data-id="element-205">
              {/* Book image with bestseller badge - consistent across all screen sizes */}
              <div className="relative max-w-xs mb-8" data-id="element-206">
                <div className="absolute inset-0 rounded-md bg-gradient-to-tr from-red-700/20 via-white/20 to-blue-700/20 transform rotate-3" data-id="element-207"></div>
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jyQ8tcFVQVnpomkTVPQ4jc/BOOK_CK.png" alt="Charlie Kirk Book Cover" className="relative z-10 w-full shadow-xl rounded-md" loading="lazy" width="300" height="450" decoding="async" data-id="element-208" />
                {/* Bestseller badge */}
                <div className="absolute -top-4 -right-4 w-24 h-24 z-20" data-id="element-209">
                  <div className="absolute inset-0 bg-red-600 rounded-full transform rotate-12" data-id="element-210"></div>
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-211">
                    <div className="text-white font-bold text-center" data-id="element-212">
                      <div className="text-xs" data-id="element-213">AMERICAN</div>
                      <div className="text-sm leading-tight" data-id="element-214">BESTSELLER</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Pricing and offer details */}
              <div className="w-full max-w-2xl" data-id="element-215">
                <div className="flex items-center justify-between mb-6" data-id="element-216">
                  <h3 className="text-xl md:text-3xl font-bold text-blue-800" data-id="element-217">
                    Get My Copy Now
                  </h3>
                  <div className="text-right" data-id="element-218">
                    <p className="text-xl line-through text-gray-500" data-id="element-219">$47.97</p>
                    <p className="text-4xl font-black text-red-700" data-id="element-220">$14.97</p>
                  </div>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8" data-id="element-221">
                  <p className="text-blue-800 font-medium text-center text-xl font-bold" data-id="element-222">
                    Includes 2 FREE BONUSES
                  </p>
                </div>
                {/* CTA button with trust indicators */}
                <div className="text-center mb-8" data-id="element-223">
                  <a href="https://shop.app/checkout/71084671162/cn/hWN3LnAlIwBXqGmJasnF0cba/en-us/shoppay" className="inline-block w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-4 px-6 rounded-lg text-xl transition-all duration-300 shadow-lg border-2 border-white transform hover:scale-105" data-id="element-224">
                    Get My Copy Now – Only $14.97
                  </a>
                  <div className="mt-4 flex items-center justify-center space-x-4" data-id="element-225">
                    <img src="https://cdn-icons-png.flaticon.com/512/6963/6963703.png" alt="Secure Payment" className="h-8 w-auto" loading="lazy" width="32" height="32" data-id="element-226" />
                    <p className="text-gray-600" data-id="element-227">Secure Payment</p>
                    <img src="https://cdn-icons-png.flaticon.com/512/2592/2592592.png" alt="Satisfaction Guaranteed" className="h-8 w-auto" loading="lazy" width="32" height="32" data-id="element-228" />
                    <p className="text-gray-600" data-id="element-229">Satisfaction Guaranteed</p>
                  </div>
                </div>
                {/* Bonus section 1 */}
                <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-lg p-6 mb-6 border border-yellow-200" data-id="element-230">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center mb-4 relative" data-id="element-231">
                    {/* Circular badge */}
                    <div className="w-16 h-16 flex-shrink-0 bg-yellow-400 rounded-full shadow-md flex flex-col items-center justify-center mb-3 sm:mb-0 sm:mr-4 transform -rotate-6 border-2 border-yellow-500" data-id="element-232">
                      <span className="text-yellow-800 text-xs font-bold leading-none" data-id="element-233">
                        FREE
                      </span>
                      <span className="text-yellow-800 text-xs font-bold leading-tight" data-id="element-234">
                        BONUS
                      </span>
                      <span className="text-yellow-800 text-sm font-black" data-id="element-235">
                        #1
                      </span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-800" data-id="element-236">
                      Exclusive Patriotic Poster (21×14)
                    </h4>
                  </div>
                  <div className="md:flex items-center gap-6" data-id="element-237">
                    <div className="md:w-1/2 relative mb-4 md:mb-0" data-id="element-238">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/roFwXPA8qv26q9HbhGs5eT/Generated_Image_September_18%2C_2025_-_4_31PM.png" alt="Free Bonus Poster - 21x14 Printable" className="w-full rounded-md shadow-md border-2 border-white" loading="lazy" width="400" height="300" decoding="async" data-id="element-239" />
                      {/* Limited Edition Badge */}
                      <div className="absolute -top-3 -right-3 bg-white rounded-full shadow-md p-1" data-id="element-240">
                        <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white text-xs font-bold py-1 px-3 rounded-full border border-gray-700" data-id="element-241">
                          LIMITED EDITION
                        </div>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-242">
                      <p className="text-gray-700 mb-2" data-id="element-243">
                        This exclusive high-resolution poster features Charlie
                        Kirk with the American flag backdrop, perfect for your
                        home office or study.
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-244">
                        ✓ High-quality digital file ready to print
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-245">
                        ✓ Easily print and frame at any local Walgreens or
                        Walmart (frame not included)
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-246">
                        ✓ Perfect gift for patriots and conservatives
                      </p>
                    </div>
                  </div>
                </div>
                {/* Bonus section 2 */}
                <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-lg p-6 mb-8 border border-yellow-200" data-id="element-247">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center mb-4 relative" data-id="element-248">
                    {/* Circular badge */}
                    <div className="w-16 h-16 flex-shrink-0 bg-yellow-400 rounded-full shadow-md flex flex-col items-center justify-center mb-3 sm:mb-0 sm:mr-4 transform -rotate-6 border-2 border-yellow-500" data-id="element-249">
                      <span className="text-yellow-800 text-xs font-bold leading-none" data-id="element-250">
                        FREE
                      </span>
                      <span className="text-yellow-800 text-xs font-bold leading-tight" data-id="element-251">
                        BONUS
                      </span>
                      <span className="text-yellow-800 text-sm font-black" data-id="element-252">
                        #2
                      </span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-800" data-id="element-253">
                      Digital Collection: "The Conservative Library"
                    </h4>
                  </div>
                  <div className="md:flex items-center gap-6" data-id="element-254">
                    <div className="md:w-1/2 relative mb-4 md:mb-0" data-id="element-255">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wYiNsMm7mzyy2S9kVD7Ljx/Generated_Image_September_22%2C_2025_-_2_27PM.png" alt="The Conservative Library - Digital Collection" className="w-full rounded-md shadow-md border-2 border-white" loading="lazy" width="400" height="300" decoding="async" data-id="element-256" />
                      {/* Exclusive Badge */}
                      <div className="absolute -top-3 -right-3 bg-white rounded-full shadow-md p-1" data-id="element-257">
                        <div className="bg-gradient-to-r from-blue-800 to-blue-900 text-white text-xs font-bold py-1 px-3 rounded-full border border-blue-700" data-id="element-258">
                          EXCLUSIVE ACCESS
                        </div>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-259">
                      <p className="text-gray-700 mb-2" data-id="element-260">
                        Get exclusive digital access to our curated collection
                        of conservative thought leadership, featuring chapters
                        from Charlie Kirk's most influential works.
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-261">
                        ✓ Digital excerpts from all three bestselling books
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-262">
                        ✓ Exclusive commentary not available anywhere else
                      </p>
                      <p className="text-green-700 font-medium" data-id="element-263">
                        ✓ Instant delivery to your email after purchase
                      </p>
                    </div>
                  </div>
                </div>
                {/* Final CTA button with trust indicators */}
                <div className="text-center" data-id="element-264">
                  <a href="https://shop.app/checkout/71084671162/cn/hWN3LnAlIwBXqGmJasnF0cba/en-us/shoppay" className="inline-block w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-4 px-6 rounded-lg text-xl transition-all duration-300 shadow-lg border-2 border-white transform hover:scale-105" data-id="element-265">
                    Get My Copy Now – Only $14.97
                  </a>
                  <div className="mt-4 flex items-center justify-center space-x-4" data-id="element-266">
                    <img src="https://cdn-icons-png.flaticon.com/512/6963/6963703.png" alt="Secure Payment" className="h-8 w-auto" loading="lazy" width="32" height="32" data-id="element-267" />
                    <p className="text-gray-600" data-id="element-268">Secure Payment</p>
                    <img src="https://cdn-icons-png.flaticon.com/512/2592/2592592.png" alt="Satisfaction Guaranteed" className="h-8 w-auto" loading="lazy" width="32" height="32" data-id="element-269" />
                    <p className="text-gray-600" data-id="element-270">Satisfaction Guaranteed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};